import styled from 'styled-components';

export const TitleWrapperCompaniesStyle = styled.h3`
  color: ${({ theme }) => {
    return theme.colors.primary;
  }};
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 5px;
`;
